import React from "react";
import styled from "styled-components";
import { Button } from "../../base_ui/inputs/button";
import MCLogo from "../media/logo";
import { PageTitle } from "../../../participant_dashboard/components/page_title";

export const SinglePageOverlay = styled.div`
  z-index: 2;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow-x: hidden;

  background-color: rgba(0, 0, 0, 0.4);

  .single-page-wrapper {
    position: relative;
    width: auto;
    display: flex;
    align-items: center;
    min-height: 100%;
    overflow-y: auto;
    max-height: calc(100vh - 300px);
  }
`;

export const StyledBackButton = styled(Button)`
  margin-bottom: ${({ theme }) => theme.sizing.scale900};

  @media ${({ theme }) => theme.deprecatedBreakpoints.medium} {
    margin-bottom: ${({ theme }) => theme.sizing.scale800};
  }
`;

export const AdminDashboardContainer = styled.div`
  margin-left: ${({ theme }) => theme.sizing.scale1600};
  margin-right: ${({ theme }) => theme.sizing.scale1600};
`;

export const ParticipantDashboardPageTitleContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.sizing.scale800};

  @media ${({ theme }) => theme.deprecatedBreakpoints.medium} {
    margin-bottom: ${({ theme }) => theme.sizing.scale600};
  }
`;

export const ParticipantDashboardContainer = styled.div<{ showEnvBanner?: boolean }>`
  margin-left: ${({ theme }) => theme.sizing.scale1600};
  margin-right: ${({ theme }) => theme.sizing.scale1600};
  padding-top: ${({ theme, showEnvBanner }) =>
    showEnvBanner ? theme.sizing.scale950 : theme.sizing.scale2400};

  @media ${({ theme }) => theme.deprecatedBreakpoints.medium} {
    margin-left: ${({ theme }) => theme.sizing.scale600};
    margin-right: ${({ theme }) => theme.sizing.scale600};
    padding-top: ${({ showEnvBanner }) => (showEnvBanner ? "26px" : "86px")};
  }
`;

// sometimes the full single page can't hide overflow, so make sure the top of the header is always rounded (for overlay)
const Header = styled.header`
  background-color: ${({ theme }) => theme.colors.white};
  padding-left: ${({ theme }) => theme.sizing.scale600};
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  place-items: center;
  box-shadow: ${({ theme }) => theme.deprecatedElevation.one};
  position: relative;
  position: sticky;
  top: 0;
  z-index: 3;
`;

const Logo = styled.div`
  flex-grow: 1;
  font-family: ${({ theme }) => theme.font.family.header};
  font-size: ${({ theme }) => theme.font.size.header.four};
  color: ${({ theme }) => theme.colors.contentPrimary};
  display: flex;
  flex-direction: row;
  padding-left: ${({ theme }) => theme.sizing.scale500};
  align-items: center;

  .logo {
    width: 45px;
    height: 45px;
    margin-right: ${({ theme }) => theme.sizing.scale300};
  }
`;

// Using only a minimal header in the Admin Dashboard
export function AdminDashboardHeader() {
  return (
    <Header>
      <Logo>
        <MCLogo className="logo" />
        admin
      </Logo>
    </Header>
  );
}

export function ParticipantDashboardPageTitle({
  title,
  subtitle,
  dataTest,
}: {
  title: string;
  subtitle: string;
  dataTest: string;
}) {
  return (
    <ParticipantDashboardPageTitleContainer>
      <PageTitle title={title} subtitle={subtitle} dataTest={dataTest} />
    </ParticipantDashboardPageTitleContainer>
  );
}
